
































import { UiIconButton, UiTextbox } from '../keen-ui';

export default {
  name: 'search-input',
  components: {
    UiIconButton,
    UiTextbox
  },
  computed: {
    selectedKeywords: function (): string {
      return this.searchInputValue.split(',').filter((value: string) => this.suggestedKeywords.includes(value));
    }
  },
  data: function () {
    return {
      searchInputValue: ''
    };
  },
  methods: {
    onQueryChange: function (): void {
      const inputEl: HTMLInputElement = (this.$refs.searchbox.$refs.input as HTMLInputElement);
      this.$emit('queryChange', inputEl.value);
    },
    toggleSelectedKeyword: function (keyword: string): void {
      const queryList = this.searchInputValue.split(',');
      if (!this.isSelectedKeyword(keyword)) {
        (queryList[0] === '' || !this.keywordsMultipleSelection) ? queryList[0] = keyword : queryList.push(keyword);
      }
      this.searchInputValue = queryList.join();
      this.$emit('queryChange', this.searchInputValue);
    },
    isSelectedKeyword: function (keyword: string): boolean {
      return this.selectedKeywords.indexOf(keyword) !== -1;
    }
  },
  props: {
    label: String,
    help: String,
    query: String,
    suggestedKeywords: Array,
    textboxVisible: Boolean,
    keywordsMultipleSelection: Boolean
  },
  created: function () {
    if (!!this.suggestedKeywords) {
      this.toggleSelectedKeyword(this.suggestedKeywords[0]);
    }
  },
  watch: {
    'suggestedKeywords': function (newValues: string[]) {
      if (!!this.suggestedKeywords) {
        this.toggleSelectedKeyword(newValues[newValues.length - 1]);
      }
    }
  }
};
